"use client";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

export function FAQ() {
	const [openIndex, setOpenIndex] = useState<number | null>(0);

	const faqs = [
		{
			question: "Est-ce que c'est vraiment pour moi ?",
			answer: "Si vous êtes indépendant, coach, thérapeute, freelance, artisan ou consultant : oui. ALTURA est pensé pour vous donner une vitrine professionnelle sans y laisser ni tout votre temps ni tout votre budget.",
		},
		{
			question: "Le site est basé sur quelle technologie ?",
			answer: "Votre site est créé avec WordPress, sur un éditeur de page rapide et simple à utiliser (guidé par des vidéos tutorielles). Si vous faites appel plus tard à un autre professionnel pour l’améliorer, il pourra repartir de cette base : je n’utilise pas de thème verrouillé qui vous rend dépendant d’un seul prestataire.",
		},
		{
			question: "Ai-je besoin d'un hébergement web ?",
			answer: "Oui. Pour que le site soit en ligne, il vous faut un nom de domaine et un hébergement. Après votre commande, vous recevez un guide pour réserver un nom de domaine (~11€ HT/an) et un hébergement à 55€/an. Si vous avez déjà tout ça, je vous indique simplement quelles informations me transmettre pour que je puisse déployer votre site.",
		},
		{
			question: "Est-ce que je peux modifier le site moi-même ?",
			answer: "Oui, c’est même le but. Vous avez accès à des vidéos courtes et simples pour apprendre à modifier textes, photos et certaines couleurs. Si vous préférez déléguer ces modifications, je peux aussi m’en charger pour vous (devis personnalisé après achat d’ALTURA).",
		},
		{
			question: "Et si je veux une page blog / une boutique ?",
			answer: "Le blog est disponible en option pour seulement +50€ (articles, catégories, commentaires inclus). Pour une boutique en ligne ou l’ajout d’une newsletter, contactez-moi : je vous conseille sur la meilleure solution et je peux intégrer ces fonctionnalités en supplément.",
		},
		{
			question: "Pourquoi ce prix aussi bas ?",
			answer: "Parce que vous partez d’un modèle déjà conçu et optimisé, que j’adapte à votre identité visuelle, et c’est vous qui saisissez vos textes et images. C’est aussi mon offre de lancement sur le premier modèle, d’où le tarif de 497€ (au lieu de 697€).",
		},
		{
			question: "Quels sont les délais de livraison ?",
			answer: "Votre site est livré en 5 jours ouvrés maximum après réception de votre brief via le Google Form. Pas de tunnel sans fin : vous savez quand vous le recevez.",
		},
		{
			question: "Est-ce que mon site sera optimisé pour Google ?",
			answer: "Votre site est techniquement préparé pour un bon référencement de base : structure propre, pages bien organisées, édition des balises essentielles. Vous recevez aussi une checklist visibilité pour améliorer vos résultats dans le temps. Comme toujours avec le SEO, aucun prestataire sérieux ne peut garantir une position précise sur Google. 😉",
		},
	];

	return (
		<section id="faq" className="py-20 bg-gray-50">
			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="font-['DM_Serif_Text',serif] text-5xl text-center text-gray-900 mb-4">
					Vous vous posez encore des questions ?
				</h2>
				<p className="text-xl text-center text-gray-600 mb-16">
					Voici les réponses aux questions les plus fréquentes
				</p>

				<div className="space-y-4">
					{faqs.map((faq, index) => (
						<div
							key={index}
							className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md transition-all"
						>
							<button
								onClick={() =>
									setOpenIndex(
										openIndex === index ? null : index,
									)
								}
								className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
							>
								<h3 className="text-lg text-gray-900 pr-4">
									{faq.question}
								</h3>
								<ChevronDown
									className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${
										openIndex === index ? "rotate-180" : ""
									}`}
								/>
							</button>
							{openIndex === index && (
								<div className="px-6 pb-6">
									<p className="text-gray-700 leading-relaxed">
										{faq.answer}
									</p>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
